// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--b24-green-dark:#5a9c51;--b24-green:#6ebc63;--b24-green-light:#77cc6c;--b24-pink:#fe6564;--b24-yellow-main:#fcee21;--b24-link:#3d70b2;--b24-link-hover:#4186df;--b24-link-visited:#71a1df;--b24-white:#fff;--b24-black-native:#000;--b24-black:#242424;--b24-gray-dark:#7d8290;--b24-gray:#aeb4c2;--b24-gray-light:#c7ccd7;--b24-gray-super-light:#e6e9ed;--b24-orange:#f2994a;--b24-red-error:#d93133;--b24-yellow:#fecb2f;--b24-yellow-light:#ffe07a}", ""]);
// Exports
module.exports = exports;
